<div class="mt-4">
  <div class="flex items-center mb-4">
    <mat-slide-toggle
      id="schedule-toggle"
      [formField]="scheduleForm.enabled"
      color="primary"
    />
    <label
      class="input-main-label my-0 ml-2"
      for="schedule-toggle"
    >Limit by schedule</label>
  </div>
  <div class="text-sm text-gray-500 mb-4">
    Outside these times the Incident Rules won't run. Device data is still monitored and stored.
  </div>

  @if (model().enabled) {
    <div class="schedule-fields">
      <div class="mb-4">
        <div class="weekday-selector">
          @for (day of weekdays; track day.value) {
            <button
              type="button"
              class="w-full rounded-md h-10"
              (click)="toggleWeekday(day.value)"
              [class.border-ui-gray-light]="!isWeekdaySelected(day.value)"
              [class.border]="!isWeekdaySelected(day.value)"
              [class.btn-green]="isWeekdaySelected(day.value)"
              [class.btn-outline]="!isWeekdaySelected(day.value)"
            >
              {{ day.label }}
            </button>
          }
        </div>
      </div>

      <div class="flex flex-wrap gap-4">
        <div class="flex-1 min-w-[150px]">
          <label class="input-main-label block mb-1">From*</label>
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              type="time"
              [formField]="scheduleForm.startTime"
              matInput
            />
          </mat-form-field>
        </div>
        <div class="flex-1 min-w-[150px]">
          <label class="input-main-label block mb-1">To*</label>
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              type="time"
              [formField]="scheduleForm.endTime"
              matInput
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</div>
